module.exports = __webpack_public_path__ + "img/52_21.7631b41f.png";